import Form from './form';





export default Form.extend( {

    bindingHandlers: {

        defaultPossibleValues: {
            set($el, value) {
                const { selected, options } = value;
                $el.html( ([ '' ].concat( options || [] ))
                    .map( s => `<option>${s}</option>` ) );
                $el.val( selected );
            },
            
            get($el, value, event) {
                return $el.val();
            }
        },

    },

} );


// WEBPACK FOOTER //
// ./src/js/view/field.fields.js